import React from "react";
import ChatWidgetConfig from "../../config/ChatWidgetConfig";
import "./styles.css";

const Footer = ({
  footerIcon = ChatWidgetConfig.footerIcon,
  footerText = ChatWidgetConfig.footerText,
}) => {
  return (
    <footer className="footer">
      <img src={footerIcon} alt="warning" loading="lazy" />
      {footerText}
    </footer>
  );
};
export default Footer;
